module.exports = {
	"en": "Coming Soon",
	"tc": "即將推出",
	"sc": "即將推出"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/coming-soon.json
// module id = 9
// module chunks = 0